<app-nav-menu ></app-nav-menu>
<div class="w-full p-[10px]">
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
